import type React from 'react';

import cx from 'classnames';

import MoreIcon from 'assets/icons/more.svg?react';
import { useStyles } from 'components/tables/players/styles';

interface StandardActionsProps {
  className?: string;
  rowItem?: any;
  onClick: (event: React.MouseEvent<SVGSVGElement, MouseEvent>, rowItem: any) => void;
}

const StandardActions: React.FC<React.PropsWithChildren<StandardActionsProps>> = ({ className, rowItem, onClick }) => {
  const { classes } = useStyles();
  const handleOnClick = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    onClick(event, rowItem);
  };

  return (
    <MoreIcon
      key={1}
      className={cx(className, classes.pointer)}
      data-img-selector="actions-wrapper"
      onClick={handleOnClick}
    />
  );
};

export default StandardActions;
